export const UNIT = 7
export const GAME_HEIGHT = window.innerHeight
export const GAME_WIDTH = window.innerWidth
export const BIRD_SIZE = UNIT * 8
export const GRAVITY = UNIT * 2
export const JUMP_SIZE = BIRD_SIZE * 2.5
export const OBSTACLE_WIDTH = BIRD_SIZE * 1.5
export const OBSTACLE_GAP = BIRD_SIZE * 5